import React, { useRef } from 'react';
import { HeroSection } from './Hero';
import { StatsBar } from './StatsBar';
import { InvestorTypesSection } from './InvestorTypesSection';
import { ProblemSection } from './ProblemSection';
import { SolutionSection } from './SolutionSection';
import { ProcessSection } from './ProcessSection';
import { ComparisonSection } from './ComparisonSection';
import { TestimonialsSection } from './TestimonialsSection';
import { DemoSection } from './DemoSection';
import RevealOnScroll from '@/components/ui/RevelOnScroll';
import { SEO } from '@/components/common/SEO';


function navScrollOffsetPx(): number {
  if (typeof window === 'undefined') return 72;
  const w = window.innerWidth;
  if (w >= 1280) return 84;
  if (w >= 1024) return 80;
  if (w >= 768) return 72;
  if (w >= 640) return 64;
  return 56;
}

const Homepage: React.FC = () => {
  const afterHeroRef = useRef<HTMLDivElement | null>(null);
  const solutionRef = useRef<HTMLDivElement | null>(null);
  const processRef = useRef<HTMLDivElement | null>(null);

  const scrollToSolution = () => {
    const el = solutionRef.current;
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - navScrollOffsetPx();
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const scrollToProcess = () => {
    const el = processRef.current;
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - navScrollOffsetPx();
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const scrollPastHero = () => {
    const el = afterHeroRef.current;
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - navScrollOffsetPx();
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen">
      <SEO
        title="VaWeNa — AI-Powered Financial Intelligence for Real Estate Investors"
        description="VaWeNa helps real estate investors track net worth, analyze portfolio performance, and generate lender-ready DSCR and Schedule E reports. WealthScope + PortfolioIQ. Start free for 14 days."
        canonical="/"
      />

      <HeroSection
        onScrollToReturnModel={scrollToSolution}
        onScrollToSolution={scrollToProcess}
        onScrollDown={scrollPastHero}
      />

      <div ref={afterHeroRef}>
        <StatsBar />
      </div>

      <RevealOnScroll direction="up">
        <InvestorTypesSection />
      </RevealOnScroll>

      <RevealOnScroll>
        <ProblemSection />
      </RevealOnScroll>

      <div ref={solutionRef}>
        <RevealOnScroll direction="up">
          <SolutionSection />
        </RevealOnScroll>
      </div>

      <div ref={processRef}>
        <RevealOnScroll direction="left">
          <ProcessSection />
        </RevealOnScroll>
      </div>

      <RevealOnScroll direction="up">
        <ComparisonSection />
      </RevealOnScroll>

      <RevealOnScroll direction="up">
        <TestimonialsSection />
      </RevealOnScroll>

      <RevealOnScroll>
        <DemoSection />
      </RevealOnScroll>
    </div>
  );
};

export default Homepage;
